import {
  ApiResponse,
  UpdateUserSettingsDto,
  UserSettingsDto,
} from '@splitsecondconnect/ultramarine-shared';
import { HttpClient } from '@angular/common/http';
import { environment } from '@marineform/environment';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MANAGE_API_PATHS } from '../data';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  #http = inject(HttpClient);

  #url(): string {
    return `${environment.ultramarineBaseUrl}/${MANAGE_API_PATHS.USER_SETTINGS}`;
  }

  getSettings(): Observable<ApiResponse<UserSettingsDto>> {
    return this.#http.get<ApiResponse<UserSettingsDto>>(this.#url());
  }

  updateSettings(
    dto: UpdateUserSettingsDto,
  ): Observable<ApiResponse<UserSettingsDto>> {
    return this.#http.put<ApiResponse<UserSettingsDto>>(this.#url(), dto);
  }
}
